<template>
  <b-container v-if="!loading" class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Dáta
          <small>({{ count }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        >
          <template #filter>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Komodita:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="energetic"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="filter.type"
                      :options="[
                        { id: 1, name: 'Elektrina' },
                        { id: 2, name: 'Plyn' },
                        { id: 3, name: 'Voda' },
                        { id: 4, name: 'Teplo' },
                      ]"
                      :searchable="false"
                      @input="search"
                      @select="changeFilterType"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          filter.type = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Stav:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="state"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="filter.state"
                      :options="[
                        { id: 1, name: 'Aktívne' },
                        { id: 2, name: 'Neaktívne' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          filter.state = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Typ merania:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="measureType"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="filter.measureType"
                      :options="[
                        { id: 1, name: 'Mesačná' },
                        { id: 2, name: 'Ročná' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          filter.measureType = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-if="filter.type === 1" md="4">
                <b-form-group
                  label="Napäťová úroveň:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="voltageVolume"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="filter.voltageVolume"
                      :options="[
                        { id: 3, name: 'NN' },
                        { id: 2, name: 'VN' },
                        { id: 1, name: 'VVN' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          filter.voltageVolume = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-if="tariffList.length" md="4">
                <b-form-group
                  :label="
                    filter.type === 1 ? 'Distrib. sadzba:' : 'Tarifná skupina:'
                  "
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="tariff"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="filter.tariff"
                      :options="tariffList"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          filter.tariff = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Ostatné:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="others"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="filter.others"
                      :options="[
                        { id: 1, name: 'S varovaním' },
                        { id: 2, name: 'Pripojené OM' },
                        { id: 3, name: 'Odpojené OM' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          filter.others = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </input-filter>
      </div>
      <template v-if="$root.user.isAdmin">
        <div v-show="$route.name === 'reportConsumer'" key="1" class="ml-3">
          <b-dropdown
            class="mr-1"
            menu-class="dropdown-menu-animated"
            right
            size="lg"
            variant="secondary"
          >
            <template #button-content>
              <b-icon icon="gear" />
            </template>
            <b-dropdown-item-button>
              <file-upload
                ref="uploadContract"
                v-model="importContractFile"
                input-id="Contract-import"
                :headers="{ Authorization: 'Bearer ' + $auth.token() }"
                :multiple="false"
                post-action="/api/energetics/contract/import"
                class="d-inline"
                @input-file="importContract"
              >
                <icon class="icon-fw mr-2" name="file-import" scale="0.75" />
                Importovať zmluvné hodnoty
              </file-upload>
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="openExportConsumerModal">
              <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
              Exportovať
            </b-dropdown-item-button>
          </b-dropdown>
          <b-btn
            v-if="$root.user.isAdmin"
            class="text-uppercase"
            size="lg"
            variant="primary"
            @click="openAddConsumerModal"
          >
            <b-icon class="mr-1" icon="plus" scale="1.5x" />
            Zadať hodnoty
          </b-btn>
        </div>
        <div v-show="$route.name === 'reportPerformance'" key="2" class="ml-3">
          <b-btn
            v-if="$root.user.isAdmin"
            class="text-uppercase"
            size="lg"
            variant="primary"
            @click="openAddPerformanceModal"
          >
            <b-icon class="mr-1" icon="plus" scale="1.5x" />
            Zadať hodnoty
          </b-btn>
        </div>
        <div v-show="$route.name === 'intervalData'" key="3" class="ml-3">
          <b-dropdown
            menu-class="dropdown-menu-animated"
            right
            size="lg"
            variant="secondary"
          >
            <template #button-content>
              <b-icon icon="gear" />
            </template>
            <b-dropdown-item-button @click="openDownloadApiModal">
              <icon class="icon-fw mr-2" name="arrow-down" scale="0.75" />
              Stiahnuť intervalové dáta
            </b-dropdown-item-button>
            <b-dropdown-item-button>
              <file-upload
                ref="uploadInterval"
                v-model="importIntervalFile"
                input-id="interval-import"
                :headers="{ Authorization: 'Bearer ' + $auth.token() }"
                :multiple="false"
                :post-action="`/api/reports/${$route.params.energetics_id}/interval/import`"
                class="d-inline"
                @input-file="importInterval"
              >
                <icon class="icon-fw mr-2" name="file-import" scale="0.75" />
                Importovať
              </file-upload>
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
      </template>
    </div>
    <add-consumer
      v-if="$store.state.energetic.current.data"
      ref="consumerForm"
    />
    <add-performance
      v-if="$store.state.energetic.current.data"
      ref="performanceForm"
    />
    <consumer-export />
    <list-api-trigger
      :id="parseInt($route.params.energetics_id)"
      ref="downloadInterval"
    />
    <b-row class="flex-grow-1" style="min-height: 1px">
      <b-col class="mh-100 col-md3cl pr-0" md="3">
        <list ref="list" :list="list" @loaded="fetchData" />
      </b-col>
      <b-col class="mh-100 col-md9ex" md="9">
        <transition mode="out-in" name="fadeShort">
          <router-view :key="$route.params.energetics_id" />
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import List from './List'
import AddConsumer from './consumer/Add'
import AddPerformance from './performance/Add'
import ConsumerExport from './consumer/Export'
import ListApiTrigger from '@/module/energetics/ListApiTrigger'
import Selectbox from '@/components/inputs/Selectbox'
import InputFilter from '@/components/InputFilter'
import FileUpload from 'vue-upload-component'

export default {
  components: {
    List,
    AddConsumer,
    AddPerformance,
    ConsumerExport,
    ListApiTrigger,
    Selectbox,
    InputFilter,
    FileUpload,
  },
  data() {
    return {
      loading: false,
      list: [],
      count: null,
      filterOptions: {
        orderBy: { column: 'typeID' },
        sortable: ['typeID', 'customers.name'],
        headings: {
          typeID: 'Komodita',
          'customers.name': 'Názov spoločnosti',
        },
      },
      tariffAttrs: [],
      filter: {
        type: null,
        state: null,
        measureType: null,
        voltageVolume: null,
        tariff: null,
        others: null,
      },
      importContractFile: [],
      importIntervalFile: [],
    }
  },
  computed: {
    tariffList() {
      if (this.filter.type) {
        return this.tariffAttrs.filter((i) =>
          i.typeID.includes(this.filter.type),
        )
      }
      return []
    },
    reportFilter() {
      return this.$store.getters['report/getFilter']
    },
  },
  watch: {
    $route() {
      if (this.list.length) {
        this.gotoFirst(this.list[0].id)
      }
    },
  },
  created() {
    this.$api
      .get('attributes/get', {
        params: {
          select: 'energetics.tariff',
        },
      })
      .then((res) => {
        this.tariffAttrs = res.data
      })
  },
  mounted() {
    this.filter.type = this.reportFilter.type
    if (this.reportFilter.customer) {
      this.$refs.filter.value = this.reportFilter.customer
    }
    this.$root.$on('reports.openConsumerModal', this.openAddConsumerModal)
    this.$root.$on('reports.openPerformanceModal', this.openAddPerformanceModal)
  },
  beforeDestroy() {
    this.$root.$off('reports.openConsumerModal')
    this.$root.$off('reports.openPerformanceModal')
    this.$store.dispatch('report/setFilter', {})
  },
  methods: {
    openAddConsumerModal({ id = null }) {
      this.$refs.consumerForm.id = id
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-consumer')
      })
    },
    openAddPerformanceModal({ id = null }) {
      this.$refs.performanceForm.id = id
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-performance')
      })
    },
    openExportConsumerModal() {
      this.$root.$emit('modal-show', 'export-consumer')
    },
    openDownloadApiModal() {
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'api-trigger')
      })
    },
    importContract(newFile, oldFile) {
      this.$refs.uploadContract.active = true
      if (newFile && oldFile) {
        if (newFile.progress !== oldFile.progress) {
          this.$swal({
            type: 'info',
            position: 'center',
            allowOutsideClick: false,
            text: 'Prebieha import...',
          })
        }

        if (newFile.success !== oldFile.success) {
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            backdrop: false,
            title: 'Import prebehol úspešne',
            timer: 5000,
          })
          this.$refs.uploadContract.clear()
        }

        if (newFile.error !== oldFile.error) {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            backdrop: false,
            title: 'Vyskytla sa chyba pri importovaní',
            timer: 5000,
          })
          this.$refs.uploadContract.clear()
        }
      }
    },
    importInterval(newFile, oldFile) {
      this.$refs.uploadInterval.active = true
      if (newFile && oldFile) {
        if (newFile.progress !== oldFile.progress) {
          this.$swal({
            type: 'info',
            position: 'center',
            allowOutsideClick: false,
            text: 'Prebieha import...',
          })
        }

        if (newFile.success !== oldFile.success) {
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Import prebehol úspešne',
            timer: 5000,
          })
          this.$refs.uploadInterval.clear()
          this.$root.$emit('reports.reloadIntervalData')
        }

        if (newFile.error !== oldFile.error) {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Vyskytla sa chyba pri importovaní',
            timer: 5000,
          })
          this.$refs.uploadInterval.clear()
        }
      }
    },
    fetchData(silent, $state) {
      this.loading = !silent
      this.$api
        .get('reports/get_list', {
          params: {
            ...this.$refs.filter.params,
            searchIn: [
              'powerNumber',
              'gasNumber',
              'waterNumber',
              'heatNumber',
              'customers.name',
              'customer_groups.name',
            ],
          },
        })
        .then((res) => {
          this.count = res.data.total
          if (res.data.rows.length) {
            this.$refs.filter.params.startAt = this.list.length + 20
            this.list = this.list.concat(res.data.rows)
            if ($state) {
              $state.loaded()
            }
            if (this.list.length / 20 === 10) {
              //$state.complete();
            }
          } else {
            $state.complete()
          }
          if (this.list[0]) {
            this.gotoFirst(this.list[0].id)
          }
          if (!silent) {
            this.loading = false
          }
        })
    },
    gotoFirst(report) {
      if (!this.$route.params.energetics_id) {
        this.$router.push({
          name: 'reportView',
          params: { energetics_id: report },
        })
      }
    },
    search() {
      this.list = []
      this.$refs.filter.params.startAt = 0
      this.$nextTick(() => {
        this.$refs.list.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
        this.$refs.filter.saveState()
      })
    },
    resetFilter() {
      this.search()
    },
    changeFilterType() {
      this.filter.voltageVolume = null
      this.filter.tariff = null
    },
  },
}
</script>
